<template>
  <div class="video-thumbnail">
    <!-- <img v-if="media.poster && media.poster.publicUrl" :src="media.poster.publicUrl" /> -->
    <v-card-media
      v-if="media.poster && media.poster.thumbnailUrl"
      :src="media.poster.thumbnailUrl"
      :style="{ width: width + 'px' }"
      :height="height"></v-card-media>

    <video-default-thumbnail
      v-else
      :width="width"
      class="default"
    ></video-default-thumbnail>
  </div>
</template>

<script>

import VideoDefaultThumbnail from '@/components/VideoDefaultThumbnail';
import CalcHeightMixin from '@/mixins/CalcHeightMixin';

export default {
  name: 'video-thumbnail',
  components: {
    VideoDefaultThumbnail,
  },
  mixins: [CalcHeightMixin],
  props: {
    media: {
      type: Object,
      required: true,
    },
    width: {
      default: 200,
    },
  },
};

</script>

<style scoped>

.video-thumbnail {
  position: relative;
}

.default {
  position: relative;
  background: #fcfcfc;
}

.video-thumbn-----ail.active:before {
  content: '';
  display: block;
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  /*background-image: linear-gradient(45deg, #16a83a 16.67%, #F6F0CF 16.67%, #F6F0CF 50%, #16a83a 50%, #16a83a 66.67%, #F6F0CF 66.67%, #F6F0CF 100%);*/
  /*background-size: 8.49px 8.49px;*/
  /*background-image: linear-gradient(45deg, #16a83a 8.33%, #F6F0CF 8.33%, #F6F0CF 50%, #16a83a 50%, #16a83a 58.33%, #F6F0CF 58.33%, #F6F0CF 100%);*/
  /*background-size: 8.49px 8.49px;*/
  /*background-image: linear-gradient(45deg, #52b56a 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #52b56a 50%, #52b56a 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 8.49px 8.49px;*/
  background-image: linear-gradient(45deg, #88a088 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #88a088 50%, #88a088 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 8.49px 8.49px;
  background-position-x: -1px;
  background-position-y: 1px;
  /*background-image: linear-gradient(45deg, #5d8066 12.50%, #fcfcfc 12.50%, #fcfcfc 50%, #5d8066 50%, #5d8066 62.50%, #fcfcfc 62.50%, #fcfcfc 100%);
  background-size: 5.66px 5.66px;*/
  /*background-image: linear-gradient(45deg, #9fb5a4 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #9fb5a4 50%, #9fb5a4 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 6.00px 6.00px;*/
  /*background-image: linear-gradient(45deg, #98b39f 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #98b39f 50%, #98b39f 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 6.00px 6.00px;*/
}

</style>



// WEBPACK FOOTER //
// src/components/VideoThumbnail.vue